/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "invoice": {
            "nested": {
              "Status": {
                "fields": {
                  "statusCode": {
                    "type": ".squareup.client.invoice.Status.StatusCode",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "StatusCode": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "UNACTIVATED": 1,
                      "TRANSIENT_ERROR": 2,
                      "PAYMENT_DECLINED": 3,
                      "NOT_FOUND": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.invoice?.nested?.Status && !$root.nested?.squareup?.nested?.client?.nested?.invoice?.nested?.Status?.nested?.StatusCode) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE Status @ squareup/client/invoice/invoice-service.proto at 32:1
 */
export const Status = $root.lookupType('squareup.client.invoice.Status');
fixType(Status);
Builder.createAndAttachToType(Status);
/**
 * SOURCE StatusCode @ squareup/client/invoice/invoice-service.proto at 33:3
 */
Status.StatusCode = $root.lookupEnum('squareup.client.invoice.Status.StatusCode').values;
